import { motion } from "motion/react";
import { useTranslation } from '../../i18n/useTranslation';
import { useResultsViewModel } from './resultsViewModel';
import styles from './ResultsDataWarning.module.scss';
import { Offscreen } from "src/lib/common/ui/Offscreen";

export function ResultsDataWarning() {
  const { t } = useTranslation();
  const viewModel = useResultsViewModel();

  const resetButtonClick = () => {
    viewModel.goToFirstStep();
  };

  return (
    <div className={ styles.container }>
      <div className={ styles.containerInner }>

        <motion.div className={ styles.block } initial={{  opacity: 0 }} animate={{  opacity: 1 }} exit={{  opacity: 0 }} transition={{ duration: 0.3 }}>
          <div className={ styles.blockInner }>

            <Offscreen as='h1'>
              { t('results_nofilters_title') }
            </Offscreen>

            <div className={ styles.content }>
              { t('results_nofilters_description') }
            </div>

            <div className={ styles.actions }>
              <button type="submit" className={ styles.ctaReset } onClick={ resetButtonClick }>
                { t('results_nofilters_reset') }
              </button>
            </div>

          </div>
        </motion.div>

      </div>
    </div>
  );
}
